import API_ENDPOINTS from "../config/apiEndpoints";
import { ensureOk, requestWithAuth } from "./apiClient";

export const apiFestivosService = {
  getFestivos: (centroId, anno, mes) => {
    return API_ENDPOINTS.FESTIVOS.ALL(anno, mes, centroId); // Devuelve directamente la URL
  },
  getByAnnoAndMesAndCentroId: async (anno, mes, centroId) => {
    const response = await requestWithAuth(API_ENDPOINTS.FESTIVOS.ALL(anno, mes, centroId));
    ensureOk(response, "Error al obtener la lista de empleados");

    return response.json();
  },
    getByAnnoAndCentroId: async (anno, centroId) => {
    const response = await requestWithAuth(API_ENDPOINTS.FESTIVOS.ALL_BY_ANNO(anno, centroId));
    ensureOk(response, "Error al obtener la lista de empleados");

    return response.json();
  },
  getFestivosCentro: async (idCentro, anno, mes) => {
    const response = await requestWithAuth(API_ENDPOINTS.FESTIVOS.ALL(anno, mes, idCentro));
    ensureOk(response, "Error");

    return response.json();
  },
  postFestivoCentro: async (idCentro, anno, mes, dia) => {
    const json = {
      centro: { id: idCentro },
      anno: anno,
      mes: mes,
      dia: dia,
    };
    const response = await requestWithAuth(API_ENDPOINTS.FESTIVOS.CREATE, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(json),
    });
    ensureOk(response, "Error");

    return response.json();
  },
  deleteFestivo: async (id) => {
    const response = await requestWithAuth(API_ENDPOINTS.FESTIVOS.DELETE(id), {
      method: "DELETE",
    });
    ensureOk(response, "Error");

    return response.json();
  },
};
